<template>
  <div class="mb-1">
    <div class="assignment-header-row" v-if="assignment && Object.keys(assignment).length > 0">
      <span class="selected-email-header">Selected Assignment</span>
      <button 
        v-if="showChangeButton"
        class="change-button" 
        @click="openAssignmentDialog"
      >
        Change Assignment
      </button>
    </div>
    <div class="pb-1"></div>
    <div>
      <AssignmentCard
        v-if="assignment && Object.keys(assignment).length > 0"
        :assignment="assignment"
        :show-link="true"
        :showActiveLabel="true"
        @select="handleAssignmentSelection"
      />
    </div>
    <AssignmentDialog 
    v-if="showDialog" 
    :visible="showDialog"
    :loadAssignments="true"
    @close="showDialog = false"
    @selectAssignment="handleAssignmentSelection"
    @refresh="fetchAssignments"
  />
  </div>
</template>

<script>
import AssignmentDialog from './AssignmentDialog.vue';
import AssignmentCard from "@/components/actions/assignment/AssignmentCard.vue";
import { mapActions } from 'vuex';

export default {
  name: 'SelectedAssignment',
  props: {
    assignment: {
      type: Object,
      required: true,
    },
    showChangeButton: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    AssignmentDialog,
    AssignmentCard
  },
  data() {
    return {
      showDialog: false
    }
  },
  methods: {
    ...mapActions({
      setSelectedAssignment: "assignments/selectAssignment",
      fetchAssignments: "assignments/fetchAssignments"
    }),
    handleAssignmentSelection(assignment) {
      this.setSelectedAssignment(assignment);
      this.showDialog = false;
    },
    openAssignmentDialog() {
      this.showDialog = true;
    }
  }
};
</script>

<style scoped>
.selected-email-header{
  font-size: 16px;
  font-weight: 400;
  line-height: 16px;
  color: #000000;
}

.change-button {
  background: var(--background-bg-highlight, #003F2D1F);
  border: none;
  color: var(--primary-default, #003F2D);
  cursor: pointer;
  font-family: Calibre-R;
  font-weight: 500;
  font-size: 14px;
  min-height: 32px;
  border-radius: 6px;
  padding: 0 12px;
  text-align: center;
  transition: all 0.2s ease;
}

.assignment-header-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.change-button:hover {
  background: #003F2D2A;
  color: #005a40;
}
</style>